import { render, staticRenderFns } from "./myanomaly-class.vue?vue&type=template&id=3d9ae5b0"
import script from "./myanomaly-class.vue?vue&type=script&lang=js"
export * from "./myanomaly-class.vue?vue&type=script&lang=js"
import style0 from "./myanomaly-class.vue?vue&type=style&index=0&id=3d9ae5b0&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d9ae5b0')) {
      api.createRecord('3d9ae5b0', component.options)
    } else {
      api.reload('3d9ae5b0', component.options)
    }
    module.hot.accept("./myanomaly-class.vue?vue&type=template&id=3d9ae5b0", function () {
      api.rerender('3d9ae5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/myanomaly-class.vue"
export default component.exports